var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClerkLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clerk-logo_svg__clip0_28400_184673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.65 13.17L67.647 25.172a2.38 2.38 0 01-2.919.35 28.556 28.556 0 00-38.196 8.146 28.614 28.614 0 00-1.015 31.065 2.38 2.38 0 01-.35 2.912L13.165 79.647a2.377 2.377 0 01-2.836.408 2.379 2.379 0 01-.765-.67 49.977 49.977 0 011.69-60.995 49.515 49.515 0 017.139-7.14A49.976 49.976 0 0179.38 9.56a2.378 2.378 0 01.27 3.61z",
    fill: "url(#clerk-logo_svg__paint0_linear_28400_184673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.638 86.787L67.636 74.785a2.38 2.38 0 00-2.92-.35 28.558 28.558 0 01-29.501 0 2.38 2.38 0 00-2.92.35L20.293 86.787a2.377 2.377 0 00.262 3.65 49.976 49.976 0 0058.806 0 2.379 2.379 0 00.277-3.65zM49.99 64.26c7.886 0 14.28-6.394 14.28-14.28 0-7.886-6.394-14.279-14.28-14.279-7.886 0-14.28 6.393-14.28 14.28 0 7.885 6.394 14.278 14.28 14.278z",
    fill: "#1F0256"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clerk-logo_svg__paint0_linear_28400_184673",
    x1: 68.37,
    y1: -7.328,
    x2: -32.853,
    y2: 93.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5D31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clerk-logo_svg__clip0_28400_184673"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h83.333v100H0z"
  })))));
}
export default SvgClerkLogo;